import './gb-search-box.tag.html';
import '../submit/gb-submit.tag.html';
import '../reset/gb-reset.tag.html';
import '../sayt/gb-sayt.tag.html';
import { Query } from './gb-query';
riot.tag2('gb-query', '<yield> <div class="gb-query {_style}"> <gb-search-box></gb-search-box> <gb-submit></gb-submit> <gb-reset></gb-reset> <gb-sayt if="{_config.sayt}"></gb-sayt> </div> </yield>', 'gb-query .gb-stylish.gb-query,[riot-tag="gb-query"] .gb-stylish.gb-query,[data-is="gb-query"] .gb-stylish.gb-query{ position: relative; display: flex; align-items: baseline; } gb-query .gb-stylish.gb-query gb-sayt,[riot-tag="gb-query"] .gb-stylish.gb-query gb-sayt,[data-is="gb-query"] .gb-stylish.gb-query gb-sayt{ top: 31px; left: 0; z-index: 10; position: absolute; min-width: 175px; background-color: #fff; box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2); }', '', function(opts) {
    this._mixin(Query);
});



/** WEBPACK FOOTER **
 ** ./src/tags/query/gb-query.tag.html
 **/